import { Config } from '../config';
import { PermittedPlate, PostPermittedPlate } from '../interfaces';
import { HttpService } from './http.service';

const pathV2 = `${Config.APIv2}`;

export abstract class PermittedPlatesService {
  public static get = (fleetUUID: string | number): Promise<PermittedPlate[]> => {
    return HttpService.fetchAuthorizedFleetless(`${pathV2}/fleets/${fleetUUID}/permitted_plates`, {
      method: 'GET',
    }).then((res) => res.plates ?? []);
  };

  public static createOrUpdate = (newPlate: PostPermittedPlate, fleetUUID: string | number): Promise<PermittedPlate[]> => {
    return HttpService.fetchAuthorizedFleetless(`${pathV2}/fleets/${fleetUUID}/permitted_plates`, {
      method: 'POST',
      body: JSON.stringify(newPlate),
    }).then((res) => res);
  };

  public static delete = (id: number, fleetUUID: string | number): Promise<PermittedPlate[]> => {
    return HttpService.fetchAuthorizedFleetless(`${pathV2}/fleets/${fleetUUID}/permitted_plates/${id}`, {
      method: 'DELETE',
    }).then((res) => res);
  };

  public static importCsv = async (csv: string, fleetUUID: string | number): Promise<PermittedPlate[]> => {
    return HttpService.fetchAuthorizedFleetless(
      `${pathV2}/fleets/${fleetUUID}/permitted_plates_csv`,
      {
        method: 'POST',
        body: csv,
      },
      undefined,
      false,
    );
  };
}
